import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import { firestoreDb } from './firebase'

const pausedWorkspaces = new Set<string>()

export const isLineSignalCapturePaused = (workspaceId: string | undefined) => Boolean(workspaceId && pausedWorkspaces.has(workspaceId))

/** Session-start subscription used by the passive flush bridge and signal emitter. */
export const useLineSignalPause = (workspaceId: string | undefined) => {
  const [paused, setPaused] = useState(() => isLineSignalCapturePaused(workspaceId))
  const [prevWorkspaceId, setPrevWorkspaceId] = useState(workspaceId)
  if (workspaceId !== prevWorkspaceId) {
    setPrevWorkspaceId(workspaceId)
    setPaused(isLineSignalCapturePaused(workspaceId))
  }
  useEffect(() => {
    if (!workspaceId) return undefined
    return onSnapshot(doc(firestoreDb, 'line_workspace_pauses', workspaceId), (snapshot) => {
      const next = snapshot.exists() && snapshot.data().paused !== false
      if (next) pausedWorkspaces.add(workspaceId)
      else pausedWorkspaces.delete(workspaceId)
      setPaused(next)
    }, () => setPaused(false))
  }, [workspaceId])
  return workspaceId ? paused : false
}

export const setLineWorkspaceCapturePaused = async (workspaceId: string, actorUid: string, paused = true) => {
  await setDoc(doc(firestoreDb, 'line_workspace_pauses', workspaceId), {
    paused, updatedBy: actorUid, updatedAt: serverTimestamp(),
  })
}
